// Name of the type fields to search
// Lumesse label and values are likely to change so we rely on "type"
export const CRITERIA_COUNTRY = 'LOV8'
export const CRITERIA_CAREER_PATH = 'LOV10'
export const CRITERIA_CONTRACT_TYPE = 'CONTRACTTYPE'
